import { DecimalPipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { LeadService } from 'src/app/shared/services/lead.services';
import { LeadStatusService } from 'src/app/shared/services/leadStatus.services';
import { UserServices } from 'src/app/shared/services/userservices';
import { LocalStorageService } from 'src/app/utility/localStorageService';
import { ReportService } from 'src/app/utility/ReportService';

@Component({
  selector: 'app-leads-journey',
  templateUrl: './leads-journey.component.html',
  styleUrls: ['./leads-journey.component.css']
})
export class LeadsJourneyComponent implements OnInit {
  students: any[] = [];  // Fill this from API
  selectedStudents: any[] = [];

  isAllStudentsSelected: boolean = true;
  selectedCounsellors: string[] = [];
  counsellors: any[] = [];

  selectedCounsellor: string = 'all';

  data: any[] = [];
  allData: any[] = [];

  displayedColumns: string[];

  totalRecords = 0;
  pageSize = 12;
  currentPage = 1;
  isAllCounsellorsSelected = true;
  loading = false;
  fromDate: any;
  toDate: any;

  statusColumns: string[] = [];  // ← FIXED TYPE
  tableData: any = [];
  totalElements: any = 0;
  totalPages: number = 1;

  constructor(private userService: UserServices,
    private leadStatusService: LeadStatusService,
    private _leadservices: LeadService,
    private decimalPipe: DecimalPipe,
    private reportService: ReportService, private localStorage: LocalStorageService) { }

  ngOnInit(): void {

    this.fromDate = this.localStorage.get("showMeLeadsFromDate");
    this.toDate = new Date();
    this.getStudentsList();
    this.getUsersList();                  // Load counsellors
    this.getLeadStatus();
    this.applyPagination();

  }

  getLeadStatus() {
    this.leadStatusService.getAllLeadStatus()
      .subscribe((resp: any[]) => {

        let dynamicStatusColumns = resp.map(s => s.statusName);

        // Add to displayedColumns
        this.displayedColumns = ["Counsellor Name", "Student Name", ...dynamicStatusColumns];
      });
  }
  getStudentsList() {
    let refNo: number = 0;
    if (this.localStorage.get("userType") != "Admin")
      refNo = Number(this.localStorage.get("refNo"));
    else
      refNo = 0
    this._leadservices.getAllLeadsByuserId(refNo, this.fromDate).subscribe(resp => {
      if (resp.length > 0) {
        let data = resp
        data.forEach(e => {
          this.students.push({ studentName: e.studentName, refNo: e.refNo })
        });
        this.selectedStudents = data.map(c => c.refNo);
        this.isAllStudentsSelected = true;
      }
    });
  }
  getUsersList() {
    this.userService.getUsersActive()
      .subscribe(
        resp => {
          this.counsellors = resp;
          this.selectedCounsellors = this.counsellors.map(c => c.refNo);
          this.isAllCounsellorsSelected = true;
        },
        (error: HttpErrorResponse) => { }
      );
  }
  toggleSelectAllStudents() {
    if (this.isAllStudentsSelected) {
      this.selectedStudents = [];
      this.isAllStudentsSelected = false;
    } else {
      this.selectedStudents = this.students.map(c => c.refNo);
      this.isAllStudentsSelected = true;
    }


  }
  applyFilter() {
    this.loading = true;
    this.reportService.getLeadJourney(
      this.selectedCounsellors,
      this.selectedStudents,
      this.formatDate(this.fromDate),
      this.formatDate(this.toDate),
      this.currentPage - 1,  // Convert to 0-based for backend
      this.pageSize
    ).subscribe({
      next: (res: any) => {
        this.tableData = [];
        this.displayedColumns = ["Counsellor Name", "Student Name"]; // reset columns

        if (res.data && res.data.length > 0) {
          // Collect all unique steps dynamically
          const allSteps = new Set<string>();
          res.data.forEach((item: any) => {
            Object.keys(item.stepCounts).forEach(step => allSteps.add(step));
          });

          // Add dynamic step columns
          this.displayedColumns.push(...Array.from(allSteps));

          // Flatten data for table with count and lastStepDate
          this.tableData = res.data.map((item: any) => {
            const flatRow: any = {
              "Counsellor Name": item.counsellorName,
              "Student Name": item.studentName
            };

            Object.keys(item.stepCounts).forEach(step => {
              const count = item.stepCounts[step] ?? 0;
              const lastDate = item.lastStepDates[step]
                ? this.formatDisplayDate(item.lastStepDates[step])
                : '';
              flatRow[step] = lastDate ? `${count} (${lastDate})` : `${count}`;
            });

            return flatRow;
          });
        }

        // Pagination info - convert backend 0-based to 1-based for frontend display
        this.totalElements = res.totalElements;
        this.totalRecords = res.totalElements;
        this.totalPages = res.totalPages;
        this.currentPage = (res.currentPage || 0) + 1;  // Convert to 1-based

        this.loading = false;
      },
      error: (err) => {
        console.error(err);
        this.loading = false;
      }
    });


  }
  formatDisplayDate(dateStr: string): string {
    // Convert yyyy-MM-dd to dd/MM/yyyy
    const date = new Date(dateStr);
    return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`;
  }
  onPageChange(event: any) {
    this.currentPage = event.pageIndex + 1;  // Convert from 0-based to 1-based for display
    this.applyFilter();
  }

  getPaginationPages(): number[] {
    const pages = [];
    const totalPages = this.totalPages || 1;
    let startPage = Math.max(1, this.currentPage - 2);
    let endPage = Math.min(totalPages, this.currentPage + 2);

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  }

  applyPagination() {
    this.data = this.allData.slice(0, this.pageSize);
  }

  fetchData() {
    this.currentPage = 1;
    this.applyFilter();
  }

  toggleSelectAll() {
    if (this.isAllCounsellorsSelected) {
      this.selectedCounsellors = [];
      this.isAllCounsellorsSelected = false;
    } else {
      this.selectedCounsellors = this.counsellors.map(c => c.refNo);
      this.isAllCounsellorsSelected = true;
    }
  }

  formatDate(date: any): string | null {
    if (!date) return null;
    return new Date(date).toISOString().substring(0, 10);
  }

  onCounsellorChange() {
    this.isAllCounsellorsSelected =
      this.selectedCounsellors.length === this.counsellors.length;
  }

  selectAll() {
    this.selectedCounsellors = this.counsellors.map(x => x.refNo);
  }

  deselectAll() {
    this.selectedCounsellors = [];
  }
}

